(function () {
  // Remove active class from all items
  const removeActiveFromAll = () => {
    document.querySelectorAll('.js-evaluation-form-item').forEach(item => {
      item.classList.remove('active');
    });
  };

  // Helper function to check if element is a form field
  const isFormField = element => {
    return element.matches('input:not([type="hidden"]), textarea, select');
  };

  // Use event delegation by attaching listeners to the document
  document.addEventListener('focusin', function (event) {
    if (isFormField(event.target)) {
      const formItem = event.target.closest('.js-evaluation-form-item');
      if (formItem) {
        removeActiveFromAll();
        formItem.classList.add('active');
      }
    }
  });

  document.addEventListener('click', function (event) {
    if (isFormField(event.target)) {
      const formItem = event.target.closest('.js-evaluation-form-item');
      if (formItem) {
        removeActiveFromAll();
        formItem.classList.add('active');
      }
    } else if (!event.target.closest('.js-evaluation-form-item')) {
      // Click was outside any form item
      removeActiveFromAll();
    }
  });

  // Handle tab key navigation
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Tab') {
      const focusedElement = document.activeElement;
      if (isFormField(focusedElement)) {
        const formItem = focusedElement.closest('.js-evaluation-form-item');
        if (formItem) {
          removeActiveFromAll();
          formItem.classList.add('active');
        }
      }
    }
  });
})();
